// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"70dde5d5","977":"2e62d078"}[chunkId] + ".chunk.js";
};